// src/components/Sidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/sidebar.css';

const Sidebar = ({ user }) => {
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>Admin Panel</h2>
      </div>

      <nav className="sidebar-nav">
        <ul>

          <li>
            <NavLink
              to="/volunteerlist"
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              <i className="icon-volunteers"></i>
              <span>Volunteers</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/bloglistadmin"
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              <i className="icon-blog"></i>
              <span>Blog Posts</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/stats-admin"
              className={({ isActive }) => isActive ? 'active' : ''}
            >
              <i className="icon-stats"></i>
              <span>Statistics</span>
            </NavLink>
          </li>

        </ul>
      </nav>

      <div className="sidebar-footer">
        <div className="user-profile">
          <img
            src={"https://i.pinimg.com/474x/23/c1/03/23c103fcf8312f7b905c42fe421caf5f.jpg"}
            alt={user?.first_name || 'User'}
            className="user-avatar"
          />
          <div className="user-info">
            <span className="user-name">User: Admin</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;

























// // src/components/Sidebar.js
// import React from 'react';
// import { NavLink } from 'react-router-dom';
// import '../styles/sidebar.css';

// const Sidebar = ({ user }) => {
//   return (
//     <aside className="sidebar">
//       <div className="sidebar-header">
//         <h2>Admin Panel</h2>
//       </div>

//       <nav className="sidebar-nav">
//         <ul>
//           {/* <li>
//             <NavLink
//               to="/admindashboard"
//               className={({ isActive }) => isActive ? 'active' : ''}
//               end
//             >
//               <i className="icon-dashboard"></i>
//               <span>Dashboard</span>
//             </NavLink>
//           </li> */}

//           {/* <li>
//             <NavLink
//               to="/content"
//               className={({ isActive }) => isActive ? 'active' : ''}
//             >
//               <i className="icon-donors"></i>
//               <span>Donors</span>
//             </NavLink>
//           </li> */}

//           <li>
//             <NavLink
//               to="/volunteerlist"
//               className={({ isActive }) => isActive ? 'active' : ''}
//             >
//               <i className="icon-volunteers"></i>
//               <span>Volunteers</span>
//             </NavLink>
//           </li>

//           <li>
//             <NavLink
//               to="/bloglistadmin"
//               className={({ isActive }) => isActive ? 'active' : ''}
//             >
//               <i className="icon-blog"></i>
//               <span>Blog Posts</span>
//             </NavLink>
//           </li>

//           {/* <li>
//             <NavLink
//               to="/"
//               className={({ isActive }) => isActive ? 'active' : ''}
//             >
//               <i className="icon-users"></i>
//               <span>User Management</span>
//             </NavLink>
//           </li> */}

//           {/* <li>
//             <NavLink
//               to="/content"
//               className={({ isActive }) => isActive ? 'active' : ''}
//             >
//               <i className="icon-content"></i>
//               <span>Content Management</span>
//             </NavLink>
//           </li> */}
//         </ul>
//       </nav>

//       <div className="sidebar-footer">
//         <div className="user-profile">
//           <img
//             src={"https://i.pinimg.com/474x/23/c1/03/23c103fcf8312f7b905c42fe421caf5f.jpg"}
//             alt={user?.first_name || 'User'}
//             className="user-avatar"
//           />
//           <div className="user-info">
//             <span className="user-name">User: Admin</span>
//           </div>
//         </div>
//       </div>
//     </aside>
//   );
// };

// export default Sidebar;